<template>
    <div>
        <button
            class="btn btn-md is-ghost px-2xl"
            title="Ändra detaljer på leveransprojektet."
            @click="$modal.show('update-delivery-project-details')"
        >
            Redigera
        </button>
        <adaptive-form-modal
            name="update-delivery-project-details"
            primary-button-text="Spara"
            primary-button-class="is-primary"
            title="Ändra leveransprojekt"
            method="patch"
            :action="route('api.delivery-projects.update', [deliveryProject])"
            :redirect-to="route('admin.delivery-projects.show', deliveryProject)"
        >
            <div>
                <text-input
                    label="Namn"
                    name="name"
                    :value="deliveryProject.name"
                    :required="true"
                    :maxlength="50"
                />
                <select-input
                    name="delivery_manager_user_id"
                    :value="deliveryProject.delivery_manager_user_id"
                    :options="availableManagers"
                    :required="true"
                >
                    Byggprojektledare
                </select-input>
                <text-input
                    label="Deadline"
                    name="deadline"
                    type="date"
                    :value="formattedDate"
                    :required="true"
                />
                <text-input
                    label="Fakturaprojekt (Fortnox)"
                    name="invoice_reference"
                    :value="deliveryProject.invoice_reference"
                    :required="false"
                    :maxlength="32"
                />
            </div>
        </adaptive-form-modal>
    </div>
</template>

<script>
    import { format } from 'date-fns';

    export default {
        props: {
            deliveryProject: {
                type: Object,
                required: true,
            },
            availableManagers: {
                type: Object,
                required: true,
            },
        },
        computed:{
            formattedDate() {
                return format(this.deliveryProject.deadline, 'YYYY-MM-DD');
            },
        },
    };
</script>
